import { render, staticRenderFns } from "./ConfigTextElement.vue?vue&type=template&id=87b9df28&scoped=true&"
import script from "./ConfigTextElement.vue?vue&type=script&lang=js&"
export * from "./ConfigTextElement.vue?vue&type=script&lang=js&"
import style0 from "./ConfigTextElement.vue?vue&type=style&index=0&id=87b9df28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b9df28",
  null
  
)

export default component.exports